import React from 'react';
import { useTranslation } from 'react-i18next';
import { Radio } from '@ff-os/shared-react/components/radio-group/Radio';
import { RadioGroup } from '@ff-os/shared-react/components/radio-group/RadioGroup';
import { ChangePhotoVariantMethod } from '../../../thunks/changePhotoVariant';
import { ChangeVariantWindowStep } from '../ChangeVariantWindowStep';
import styles from '../ChangeVariantWindow.module.scss';

export const ChangeMethodStep = ({ value, imageUrl, onChange, stepper }: Props) => (
    <ChangeVariantWindowStep imageUrl={imageUrl} className={styles.methodContainer} stepper={stepper}>
        <RadioGroup className={styles.radioGroup}>
            <Option method='copy' activeMethod={value} setMethod={onChange} />
            <Option method='move' activeMethod={value} setMethod={onChange} />
        </RadioGroup>
    </ChangeVariantWindowStep>
);

type Props = {
    stepper?: () => JSX.Element;
    imageUrl?: string;
    value: ChangePhotoVariantMethod | undefined;
    onChange: (value: ChangePhotoVariantMethod) => void;
};

const Option = ({ method, activeMethod, setMethod }: OptionProps) => {

    const { t } = useTranslation();
    const text = t(`photo_prints.options.method.${method}.long`);

    return (
        <Radio
            label={text} value={method}
            active={activeMethod === method} onClick={() => setMethod(method)}>
            {text}
        </Radio>
    );
};

type OptionProps = {
    method: 'move' | 'copy';
    activeMethod: 'move' | 'copy' | undefined;
    setMethod: (method: ChangePhotoVariantMethod) => void;
};